class UserStatuses {
  constructor() {
    
    let statuses = {
      'active': 1,
      'invited': 2,
      'disabled': 0
    }

    this.getKeyByValue = (value) => {
      let values = Object.values(statuses)
      let key = values.find(key => values[key] === value)
      return Object.keys(statuses)[key];
    }

    this.getStatuses = () => {
      return statuses
    }
  }
  
}
export default new UserStatuses